/* KOSZYK PUFY - czesc 2/2: stopka panelu i rekomendacje.
   Wymaga window.KT z koszyk-test.js - ladowany PO nim.
   Pelny opis dzialania: doc projektu "koszyk-stan-prac". */

(function () {
  'use strict';

  var KT = window.KT;
  if (!KT) return;

  var ROOT = KT.ROOT, esc = KT.esc, money = KT.money, announce = KT.announce;

  /* KONFIGURACJA
     Konto klienta pufy.pl dziala na nowych kontach Shopify, stad pelny
     adres portalu. Polityki to standardowe sciezki /policies/*.
     Wiersze pomocy sa zwyklymi linkami - klik prowadzi wprost na strone
     polityki, bez rozwijania streszczenia w panelu. */
  var SERVICE_LINKS = [
    {
      label: 'Śledź zamówienie',
      href:  'https://shopify.com/94157930878/account/orders'
    },
    {
      label: 'Wysyłka i płatności',
      href:  '/policies/shipping-policy'
    },
    {
      label: 'Zwroty produktów',
      href:  '/policies/refund-policy'
    },
    {
      label: 'Kontakt',
      href:  '/pages/kontakt'
    }
  ];

  /* Pytanie, zeby czytalo sie rownolegle do "Masz kod rabatowy?".
     Alternatywa, jesli wolisz rzeczownik: 'Przydatne informacje'. */
  var HELP_TITLE = 'Potrzebujesz pomocy?';

  /* Odpowiednik "Looking for more?" z SKIMS. Zrodlo: kolekcja bestsellery. */
  var MORE = { handle: 'bestsellery', title: 'Szukasz czegoś jeszcze?', limit: 8 };

  var COUPON_TEXT = {
    toggle:      'Masz kod rabatowy?',
    placeholder: 'Kod rabatowy',
    submit:      'Zastosuj',
    empty:       'Wpisz kod.',
    invalid:     'Kod nieprawidłowy lub nie dotyczy tego koszyka.',
    error:       'Coś poszło nie tak. Spróbuj ponownie.',
    ok:          'Kod został zastosowany.'
  };

  var CHEVRON = '<svg class="kt-acc__chev" width="12" height="7" viewBox="0 0 12 7" fill="none" aria-hidden="true">' +
                '<path d="M1 1l5 5 5-5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>';

  /* Strzalka w prawo - wiersze pomocy prowadza gdzies indziej, wiec nie moga
     wygladac jak cos, co sie rozwija w miejscu. */
  var ARROW = '<svg class="kt-pol__arrow" width="7" height="12" viewBox="0 0 7 12" fill="none" aria-hidden="true">' +
              '<path d="M1 1l5 5-5 5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* AKORDEON Z KODEM + POLITYKI - na gorze stopki, nad suma.
     Kod leci przez /cart/update.js z parametrem discount (Cart AJAX API,
     maj 2025). Odswiezenie panelu robi zdarzenie motywu 'cart:refresh'.
     Motywowy przycisk kuponu jest ukryty przez CSS. */

  function buildFooterExtras() {
    var footer = document.querySelector('cart-drawer .drawer__footer');
    if (!footer || footer.hidden) return;
    if (footer.querySelector('.kt-extras')) return;   // juz jest

    var box = document.createElement('div');
    box.className = 'kt-extras';

    /* Wiersze pomocy = zwykle linki. Zaden nie ma stanu otwarty/zamkniety.
       Kontakt jest ostatni: to wyjscie awaryjne, gdy trzy pierwsze nie wystarcza. */
    var links = SERVICE_LINKS.map(function (l) {
      return '<a class="kt-pol__row" href="' + l.href + '">' +
               '<span>' + esc(l.label) + '</span>' + ARROW +
             '</a>';
    }).join('');

    box.innerHTML =
      '<details class="kt-acc">' +
        '<summary class="kt-acc__toggle">' +
          '<span>' + esc(COUPON_TEXT.toggle) + '</span>' + CHEVRON +
        '</summary>' +
        '<div class="kt-acc__body">' +
          '<form class="kt-code" novalidate>' +
            '<label class="kt-sr" for="kt-code-input">' + esc(COUPON_TEXT.placeholder) + '</label>' +
            '<input id="kt-code-input" class="kt-code__input" type="text" name="discount" ' +
                   'placeholder="' + esc(COUPON_TEXT.placeholder) + '" autocomplete="off" ' +
                   'autocapitalize="characters" spellcheck="false">' +
            '<button class="kt-code__submit" type="submit">' + esc(COUPON_TEXT.submit) + '</button>' +
          '</form>' +
          '<p class="kt-code__msg" role="status" aria-live="polite" hidden></p>' +
        '</div>' +
      '</details>' +
      '<details class="kt-acc">' +
        '<summary class="kt-acc__toggle">' +
          '<span>' + esc(HELP_TITLE) + '</span>' + CHEVRON +
        '</summary>' +
        '<nav class="kt-acc__body kt-acc__body--nested">' + links + '</nav>' +
      '</details>';

    footer.insertBefore(box, footer.firstChild);
    box.querySelector('.kt-code').addEventListener('submit', onCouponSubmit);
  }

  function onCouponSubmit(e) {
    e.preventDefault();
    var form  = e.currentTarget;
    var input = form.querySelector('.kt-code__input');
    var btn   = form.querySelector('.kt-code__submit');
    var msg   = form.parentNode.querySelector('.kt-code__msg');
    var code  = (input.value || '').trim();

    function say(text, ok) {
      msg.textContent = text;
      msg.hidden = false;
      msg.classList.toggle('is-ok', !!ok);
    }

    if (!code) { say(COUPON_TEXT.empty, false); input.focus(); return; }

    btn.disabled = true;
    msg.hidden = true;

    fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        var applied = res.ok && (res.data.discount_codes || []).some(function (d) {
          return d.applicable && String(d.code).toLowerCase() === code.toLowerCase();
        });

        if (applied) {
          say(COUPON_TEXT.ok, true);
          announce(COUPON_TEXT.ok);
          KT.state.cartCache = null;
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        } else {
          say(COUPON_TEXT.invalid, false);
          announce(COUPON_TEXT.invalid);
          input.select();
        }
      })
      .catch(function () { say(COUPON_TEXT.error, false); })
      .finally(function () { btn.disabled = false; });
  }

  /* SEKCJA POLECANYCH - bestsellery pod pozycjami koszyka.
     Karty prowadza na PDP, bez szybkiego dodawania: przy 19 kolorach
     wybor wariantu musi byc swiadomy. */

  var moreCache = null, moreFetching = null;

  function getMore() {
    if (moreCache) return Promise.resolve(moreCache);
    if (moreFetching) return moreFetching;
    moreFetching = fetch(ROOT + 'collections/' + MORE.handle + '/products.json?limit=' + (MORE.limit + 4),
                         { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { moreCache = (d && d.products) || []; moreFetching = null; return moreCache; })
      .catch(function () { moreFetching = null; return []; });
    return moreFetching;
  }

  function minPrice(p) {
    var vs = (p.variants || []).map(function (v) { return parseFloat(v.price); })
                               .filter(function (n) { return !isNaN(n); });
    return vs.length ? Math.min.apply(null, vs) : null;
  }

  function currency() {
    return (KT.state.cartCache && KT.state.cartCache.currency) ||
           (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PLN';
  }

  function buildMore() {
    /* UWAGA: motyw ma DWA elementy .drawer__body - pierwszy to pusty stan
       (#CartDrawerEmpty), drugi to lista pozycji. querySelector zwracal ten
       pierwszy, wiec kotwica nigdy sie nie znajdowala. Szukamy od drawera. */
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    if (drawer.querySelector('.kt-more')) return;

    // kotwica: pod rekomendacjami motywu, a jesli ich nie ma - pod lista pozycji
    var anchor = drawer.querySelector('cart-drawer-products-recommendation') ||
                 drawer.querySelector('cart-items');
    if (!anchor) return;

    // nie proponuj tego, co klient juz ma w koszyku
    var inCart = [].map.call(drawer.querySelectorAll('.cart-item[data-handle]'), function (el) {
      return el.getAttribute('data-handle');
    });

    getMore().then(function (products) {
      if (!products.length) return;
      if (drawer.querySelector('.kt-more')) return;

      var cur = currency();
      var cards = products
        .filter(function (p) { return inCart.indexOf(p.handle) === -1; })
        .slice(0, MORE.limit)
        .map(function (p) {
          var price = minPrice(p);
          var img = (p.images && p.images[0] && p.images[0].src) || '';
          if (img) img = img.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2');
          return '<li class="kt-more__item">' +
                   '<a href="' + ROOT + 'products/' + p.handle + '">' +
                     (img ? '<img src="' + img + '" alt="" loading="lazy" width="128" height="128">'
                          : '<span class="kt-more__ph"></span>') +
                     '<span class="kt-more__name">' + esc(p.title) + '</span>' +
                     (price != null ? '<span class="kt-more__price">' + money(price * 100, cur) + '</span>' : '') +
                   '</a>' +
                 '</li>';
        }).join('');

      if (!cards) return;

      var sec = document.createElement('section');
      sec.className = 'kt-more';
      sec.innerHTML = '<h3 class="kt-more__title">' + esc(MORE.title) + '</h3>' +
                      '<ul class="kt-more__list">' + cards + '</ul>';
      anchor.parentNode.insertBefore(sec, anchor.nextSibling);
    });
  }

  /* Cykl zycia. Stopka i cialo panelu sa podmieniane przez innerHTML przy
     kazdej zmianie koszyka, a nie kazda sciezka emituje zdarzenie - dlatego
     obserwator DOM. refresh() jest idempotentny, wiec petli nie bedzie. */
  function refresh() {
    KT.priceInCheckoutButton();
    buildFooterExtras();
    buildMore();
    KT.bindAll();
  }

  var moTimer;
  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.ktWatched) return;
    drawer.dataset.ktWatched = '1';
    new MutationObserver(function () {
      clearTimeout(moTimer);
      moTimer = setTimeout(refresh, 60);
    }).observe(drawer, { childList: true, subtree: true });
  }

  document.addEventListener('cart:updated', function () {
    KT.state.cartCache = null;
    refresh();
    KT.bumpCount();
  });
  document.addEventListener('product-ajax:added', function () { KT.state.cartCache = null; });
  document.addEventListener('recommendations:loaded', refresh);

  function init() {
    if (!document.getElementById('kt-live')) document.body.appendChild(KT.live);
    watchDrawer();
    refresh();
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.subscribe) {
      FoxTheme.pubsub.subscribe('cart-update', function () { KT.state.cartCache = null; refresh(); });
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();
})();
